import React, { FC } from "react";
import Button from "../../pages/For Business/components/Button";
import { userDataStore } from "../../../../store/userData";
import { useSnapshot } from "valtio";
import { useNavigate } from "react-router-dom";
import {
  FibiAiQuery,
  FibiAiQueryValue,
} from "../../pages/FiBi/voice/components/data";
import { WebPaths } from "../../../../routes/data";

interface Props {
  hideHeader?: boolean;
}

const FiBiUsersContent: FC<Props> = ({ hideHeader }) => {
  const navigate = useNavigate();
  const { userData } = useSnapshot(userDataStore);

  const onToFibiAI = () => {
    navigate(
      `${WebPaths.FiBiVoice}?${FibiAiQuery.userType}=${FibiAiQueryValue.fibiUser}`
    );
  };
  return (
    <div className={`flex flex-col gap-4 ${hideHeader ? "" : "py-6 mb-10"}`}>
      {!hideHeader && (
        <h5 className="text-xl font-medium text-primaryColor">FiBi AI</h5>
      )}

      <p className="">
        Meet FiBi AI - Your Personal Interview Trainer. Practice real U.S. visa
        interview questions with both text and voice simulations to boost your
        confidence and approval chances.
      </p>

      <div className="flex items-center justify-center md:w-[30%] mx-auto [&>button]:w-full">
        <Button
          text={`${
            userData?.fibiSubInfo
              ? "Start Your Practice Now"
              : "Try Now For Free"
          }`}
          type="button"
          onClick={onToFibiAI}
        />
      </div>
    </div>
  );
};

export default FiBiUsersContent;
